module.exports = __webpack_public_path__ + "img/_select.7323daa9.svg";